import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description:
      'Please provide the mandate signed by your client for the company {companyName}.',
    title: 'Add the mandate for\n{companyName}',
  },
  fr: {
    description:
      'Merci de nous transmettre le mandat signé par votre client•e pour l’entreprise {companyName}.',
    title: 'Ajouter le mandat pour\n{companyName}',
  },
} as const);
